import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from "react";
export const GalleryCardImageWrapper = /*#__PURE__*/ memo((param)=>{
    let { children } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: "pointer-events-none absolute inset-0 overflow-hidden rounded-4",
        children: [
            children,
            /*#__PURE__*/ _jsx("div", {
                className: "absolute inset-0 bg-gradient-to-t from-black/60 from-20% to-black/20"
            })
        ]
    });
});
GalleryCardImageWrapper.displayName = "GalleryCardImageWrapper";
